import axios from 'axios';
/* const api = axios.create({baseURL:'https://fast-inlet-20561.herokuapp.com/api'}); */
const api = axios.create({baseURL:'https://us-central1-elasprogramamapi.cloudfunctions.net/app'});

/* const api = axios.create({baseURL:'http://localhost:8080'}); */
/* const api = axios.create({baseURL:'http://localhost:4001/api'}); */

export default  api
